import { CardFooter, Table } from "reactstrap";
import { Class, ValueOfClass } from "../../../../utils/Constant";
import { GridCommonCardFooterType } from "../../../../Type/Ui-Kits/UiKitsTypes";

const GridCommonCardFooter:React.FC<GridCommonCardFooterType> = ({ className, valueClass }) => {
  return (
    <CardFooter>
      <div className="custom-scrollbar">
        <Table className="w-100" responsive borderless>
          <tbody>
            <tr>
              <th>{Class}</th>
              <th className="f-w-800">{ValueOfClass}</th>
            </tr>
            <tr>
              <td><code>{className}</code></td>
              <td>{valueClass}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </CardFooter>
  );
};

export default GridCommonCardFooter;